import React from 'react';
import PhoneInputWithCountry from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../styles/PhoneInput.css';

/**
 * International Phone Input Component with Country Selector
 * Uses react-phone-number-input for country flags and dial codes
 */
const PhoneInput = ({
  value,
  onChange,
  name,
  placeholder = 'Your WhatsApp number here',
  required = false,
  error = null,
  autoFilled = false
}) => {
  const handleChange = (phoneValue) => {
    // Create synthetic event for compatibility with form handling
    const syntheticEvent = {
      target: {
        name: name,
        value: phoneValue || ''
      }
    };
    onChange(syntheticEvent);
  };

  const containerClasses = ['phone-input'];
  if (error) containerClasses.push('error');
  if (autoFilled) containerClasses.push('autofilled');

  return (
    <div className="phone-input-wrapper">
      <PhoneInputWithCountry
        international
        defaultCountry="AE"
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        className={containerClasses.join(' ')}
        countryCallingCodeEditable={false}
        required={required}
      />
      {error && <div className="field-error">{error}</div>}
    </div>
  );
};

export default PhoneInput;
